export default __webpack_public_path__ + "static/media/bg4.3defee3e.jpg";